// Add your styles here, and reference them in your component className
import { css } from '@linaria/core';

export const style = css`
  display: flex;
  justify-content: center;
`;
